export default "__VITE_ASSET__hkbh1D8E__"